export default __webpack_public_path__ + "static/media/15.0985e8b7.jpg";